const parsePhoneNumber = (phone) => Number(phone.replace(/[^0-9]/g, ''));

const joinFullName = (surname, firstName, secondName) => `${surname} ${firstName} ${secondName}`;

const check = (value) => (value === 'Наличные' ? 0 : 1);

function getTypeOfCargo(type) {
  switch (type) {
    case 'Стандарт':
      return 'Standart';
    case 'Цилиндры':
      return 'Cylinder';
    case 'Шины':
      return 'Tires';
  }
}

function getCylinderSize(dataForm) {
  const { diameter, height } = dataForm.cargoInformation.sizeOfCargoCylinder;

  const fullVolume = (3.1415 * Math.pow(diameter / 2, 2) * height) / Number(dataForm.cargoInformation.numberOfIdenticalLoads);
  const heightCy = Math.pow((fullVolume * 4) / 3.1415, 1 / 3);
  return { diameter: heightCy, height: heightCy };
}

const getTypesOfPayment = (dataForm) => {
  const typePickup = check(dataForm.sender.typeOfPaymentZabor);
  const typeTransportation = check(dataForm.thirdPerson.typeOfPaymentCargoTransportation);
  const typeDelivery = check(dataForm.consignee.typeOfPaymentCargoDelivery);
  const typeExtraPacking = dataForm.cargoInformation.additionalPackaging ? check(dataForm.cargoInformation.typeOfPaymentForCargoExtraPacking) : typeTransportation;

  return { typePickup, typeTransportation, typeDelivery, typeExtraPacking };
};

function getTypeOfPackaging(types) {
  return {
    palletizing: types.indexOf('Паллетирование') != -1,
    stretchFilm: types.indexOf('Стретч-пленка') != -1,
    lathing: types.indexOf('Обрешётка') != -1,
    poddon: types.indexOf('Поддон') != -1,
    box25x18x10: types.indexOf('Коробка 25x18x10') != -1,
    box38x30x23: types.indexOf('Коробка 38x30x23') != -1,
    packet: types.indexOf('Пакет') != -1,
  };
}

function parseObjectInNumber(obj) {
  return Object.entries(obj).reduce((accum, [key, value]) => {
    accum[key] = Number(value);
    return accum;
  }, {});
}

const generateObligation = (dataForm) => {
  const { typeDelivery, typeExtraPacking, typePickup, typeTransportation } = getTypesOfPayment(dataForm);
  return {
    ptAddrPickUp: typePickup,
    ptGasolinePickUp: typePickup,
    ptCarrying: typeTransportation,
    ptAddrDelivery: typeDelivery,
    ptGasolineDelivery: typeDelivery,
    ptPacking: typeExtraPacking,
  };
};

function getTime(date, time) {
  if (!date || !time) {
    return;
  }

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const hour = time.slice(0, 2);
  const minute = time.slice(3, 5);

  const dateTime = new Date(year, month, day, hour, minute);

  return dateTime;
}

function generateObligationPattern(isControgent, dataForm) {
  const { typeDelivery, typeExtraPacking, typePickup, typeTransportation } = getTypesOfPayment(dataForm);

  const isWhoPayPickup = dataForm.sender.whoPaysZabor === isControgent;
  const isWhoPayTransportation = dataForm.thirdPerson.whoPaysCargoTransportation === isControgent;
  const isWhoPayDelivery = dataForm.consignee.whoPaysCargoDelivery === isControgent;
  const isWhoPayExtraPacking = dataForm.cargoInformation.additionalPackaging ? dataForm.cargoInformation.whoPaysForCargoExtraPacking === isControgent : isWhoPayTransportation;

  const type = isWhoPayPickup ? typePickup : isWhoPayTransportation ? typeTransportation : isWhoPayDelivery ? typeDelivery : isWhoPayExtraPacking ? typeExtraPacking : 1;
  return {
    addrPickUp: isWhoPayPickup,
    gasolinePickUp: isWhoPayPickup,
    waitingPickUp: isWhoPayPickup,
    carrying: isWhoPayTransportation,
    returnDocs: dataForm.cargoInformation.returnOfDocuments && isWhoPayTransportation,
    ptReturnDocs: type,
    addrDelivery: isWhoPayDelivery,
    waitingDelivery: isWhoPayDelivery,
    gasolineDelivery: isWhoPayDelivery,
    packing: isWhoPayExtraPacking,
    warmPlace: isWhoPayExtraPacking,
    ptAddrPickUp: type,
    ptGasolinePickUp: type,
    ptWaitingPickUp: type,
    ptCarrying: type,
    ptAddrDelivery: type,
    ptGasolineDelivery: type,
    ptWaitingDelivery: type,
    ptPacking: type,
    ptWarmPlace: type,
    insuranceForValue: isWhoPayTransportation,
    ptInsuranceForValue: type,
  };
}

export const createBody = (dataForm) => {
  const body = {
    comment: dataForm.sender.sendTo ? `(Данные на водителя ${dataForm.sender.sendTo}) ${dataForm.sender.comment}` : dataForm.sender.comment,

    transportation: {
      cityFrom: dataForm.sender.cityFrom,
      cityTo: dataForm.consignee.cityTo,
    },

    cashOnDelivery: {
      sum: Number(dataForm.cargoInformation.cashOnDeliverySum),
    },

    sender: {
      phone: parsePhoneNumber(dataForm.sender.phoneSender),
      name: joinFullName(dataForm.sender.surnameSender, dataForm.sender.firstNameSender, dataForm.sender.secondNameSender),
      email: dataForm.sender.emailSender,
      corpClient: {
        inn: dataForm.sender.innSender,
        title: dataForm.sender.name,
        fullTitle: dataForm.sender.name,
      },
      obligation: {
        ...generateObligation(dataForm),
      },
      obligationPattern: {
        comissionForCashOnDelivery: !!dataForm.cargoInformation.cashOnDelivery,
        ...generateObligationPattern('Отправитель', dataForm),
      },
    },

    documentReturn: dataForm.cargoInformation.returnOfDocuments,

    repurchaseCargo: dataForm.cargoInformation.cargoRedemptionSum
      ? {
          sum: Number(dataForm.cargoInformation.cargoRedemptionSum),
          whoRepurchaseCargo: dataForm.cargoInformation.whoPaysTheRansom ? Number(dataForm.cargoInformation.whoPaysTheRansom) : 0,
        }
      : null,

    consignee: {
      phone: parsePhoneNumber(dataForm.consignee.phoneConsignee),
      name: joinFullName(dataForm.consignee.surnameConsignee, dataForm.consignee.firstNameConsignee, dataForm.consignee.secondNameConsignee),
      email: dataForm.consignee.emailConsignee,
      corpClient: {
        inn: dataForm.consignee.innConsignee,
        title: dataForm.consignee.name,
        fullTitle: dataForm.consignee.name,
      },
      obligation: generateObligation(dataForm),
      obligationPattern: generateObligationPattern('Получатель', dataForm),
    },

    customer: {
      phone: parsePhoneNumber(dataForm.thirdPerson.phoneThirdPerson),
      name: joinFullName(dataForm.thirdPerson.surnameThirdPerson, dataForm.thirdPerson.firstNameThirdPerson, dataForm.thirdPerson.secondNameThirdPerson),
      email: dataForm.thirdPerson.emailThirdPerson,
      corpClient: {
        inn: dataForm.thirdPerson.innThirdPerson,
        title: dataForm.thirdPerson.name,
        fullTitle: dataForm.thirdPerson.name,
      },
      obligation: generateObligation(dataForm),
      obligationPattern: generateObligationPattern('Третье лицо', dataForm),
    },
    // ????????????
    pickUp:
      dataForm.sender.senderZaborType === 'Сдать на склад'
        ? null
        : {
            address: {
              city: dataForm.sender.cityFrom,
              address: dataForm.sender.addressCargoPickup,
            },
            pickupsFrom: getTime(dataForm.sender.pickUpDate, dataForm.sender.cargoTimePickup.split('-')[0]),
            pickupsTo: getTime(dataForm.sender.pickUpDate, dataForm.sender.cargoTimePickup.split('-')[1]),
            // pickupsBreakFrom: getBreakTime(dataForm.applicationCargoPickup.startTimeLunchBreak),
            // pickupsBreakTo: getBreakTime(dataForm.applicationCargoPickup.endTimeLunchBreak),
            powerOfAttorney: dataForm.sender.typePowerOfAttorney ? Number(dataForm.sender.typePowerOfAttorney) : 0,
          },

    delivery:
      dataForm.consignee.consigneeDeliveryType === 'Забрать на складе'
        ? null
        : {
            address: {
              city: dataForm.consignee.cityTo,
              address: dataForm.consignee.addressCargoDelivery,
            },
            deliveryFrom: getTime(new Date('1970-07-07'), dataForm.consignee.cargoTimeDelivery.split('-')[0]),
            deliveryTo: getTime(new Date('1970-07-07'), dataForm.consignee.cargoTimeDelivery.split('-')[1]),
            // deliveryBreakFrom: getBreakTime(dataForm.applicationCargoPickup.startTimeLunchBreakDelivery),
            // deliveryBreakTo: getBreakTime(dataForm.applicationCargoPickup.endTimeLunchBreakDelivery),
          },

    value: Number(dataForm.cargoInformation.cargoCost),
    cargoList: new Array(Number(dataForm.cargoInformation.numberOfIdenticalLoads)).fill({
      cargoDescription: dataForm.cargoInformation.natureOfCargo,
      typeOfCargo: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
      value: Number(dataForm.cargoInformation.cargoCost),
      weight: dataForm.cargoInformation.cargoWeight ? Number(dataForm.cargoInformation.cargoWeight) / Number(dataForm.cargoInformation.numberOfIdenticalLoads) : 14.0,
      ...getTypeOfPackaging(dataForm.cargoInformation.typeOfPackaging),
      numberOfIdenticalLoads: 1,
      warmPlace: dataForm.cargoInformation.warmPlace,
      sizeOfCargoBox:
        getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Standart'
          ? parseObjectInNumber({
              length: dataForm.cargoInformation.cargoDimensions.length ? dataForm.cargoInformation.cargoDimensions.length / Number(dataForm.cargoInformation.numberOfIdenticalLoads) : 43,
              width: dataForm.cargoInformation.cargoDimensions.width ? dataForm.cargoInformation.cargoDimensions.width : 21,
              height: dataForm.cargoInformation.cargoDimensions.height ? dataForm.cargoInformation.cargoDimensions.height : 39,
            })
          : null,
      sizeOfCargoCylinder:
        getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Standart' ? null : getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) === 'Tires' ? { tire: true } : getCylinderSize(dataForm),
    }),
  };

  if (!(dataForm.thirdPerson.cargoTransportationCustomer === 'Третье лицо')) {
    const obligation = { ...body.customer.obligation };
    const obligationPattern = { ...body.customer.obligationPattern };
    body.customer = dataForm.thirdPerson.cargoTransportationCustomer === 'Отправитель' ? { ...body.sender } : { ...body.consignee };
    body.customer.obligation = obligation;
    body.customer.obligationPattern = obligationPattern;
  }

  return body;
};
